import { cn } from "@/utils/cn";
import { useState } from "react";

const SIZES = [0.9, 1, 1.15, 1.3, 1.5];
const DEFAULT = 1;
const KEY = "fast-dataset-text-size";

function stored(): number {
  try {
    const n = Number(localStorage.getItem(KEY));
    return SIZES.includes(n) ? n : DEFAULT;
  } catch {
    return DEFAULT;
  }
}

export function useTextSize() {
  const [size, setSize] = useState(stored);
  const step = (by: number) => {
    const next = SIZES[Math.min(SIZES.length - 1, Math.max(0, SIZES.indexOf(size) + by))];
    setSize(next);
    try {
      localStorage.setItem(KEY, String(next));
    } catch {
      // private mode: the size still applies for this visit
    }
  };
  return { size, step };
}

export function TextSizeToggle({ size, step }: ReturnType<typeof useTextSize>) {
  const at = SIZES.indexOf(size);
  const button = "flex h-6 w-7 items-center justify-center text-zinc-500 hover:bg-zinc-50 hover:text-zinc-900 disabled:text-zinc-300 disabled:hover:bg-transparent";
  return (
    <div className="font-ui flex items-center rounded-[3px] border border-zinc-200" role="group" aria-label="Table text size">
      <button type="button" className={cn(button, "text-[11px]")} disabled={at <= 0} onClick={() => step(-1)} title="Smaller text" aria-label="Smaller text">
        A
      </button>
      <span className="w-9 border-x border-zinc-200 text-center text-2xs tabular-nums text-zinc-500" aria-live="polite">
        {Math.round(size * 100)}%
      </span>
      <button type="button" className={cn(button, "text-[15px]")} disabled={at >= SIZES.length - 1} onClick={() => step(1)} title="Larger text" aria-label="Larger text">
        A
      </button>
    </div>
  );
}
